import React, { useState } from "react";
import AIChatbotSettingsTrainingTabFile from "./AIChatbotFileTrainingIndex";
import AIChatbotTrainingSettingsTabs from "./AIChatbotTrainingSettingsTab";
import AIChatbotWebTrainingIndex from "./AIChatbotWebTrainingIndex";
import { PrimaryBlueButton, Severity } from "@velaro/velaro-component-lib";
import useToastAlert from "@/hooks/useToastAlert";
import useApi from "@/hooks/useApi";

export default function AIChatbotWebTraining() {
  const [pythonOutput, setPythonOutput] = useState<string>("");
  const toastAlert = useToastAlert();
  const api = useApi();

  async function runPythonScript() {
    const result = await api.messaging.post(`WebScraping/RunPythonScript`);
    const response = await result.text();
    if (result.ok) {
      toastAlert.displayToast(
        Severity.Success,
        "Python script ran successfully"
      );
      setPythonOutput(response);
    } else {
      toastAlert.displayToast(Severity.Error, "Failed to run python script");
    }
  }

  return (
    <div>
      <AIChatbotTrainingSettingsTabs selectedTab={"Web Training"} />
      <div className="flex items-center justify-center">
        <div className="bg-white p-6 border-[1px] rounded-2xl shadow-sm w-3/4 self-center ">
          <AIChatbotWebTrainingIndex />
        </div>
      </div>
      {/* <div className="flex flex-row justify-center mt-4">
        <div className="pt-4 border-[1px] p-6 shadow-sm rounded-2xl flex flex-col w-[725px]">
          <PrimaryBlueButton
            label="Python Script Testing"
            onClick={runPythonScript}
          />

          <div className="text-slate-500 pt-4">Python Results:</div>
          <div className="text-black whitespace-pre-line">{pythonOutput}</div>
        </div>
      </div> */}
    </div>
  );
}
